import React from 'react';
import { useSelector } from 'react-redux';
import { selectRole, selectRoute, selectRouteSimple, selectUlogovan } from '../redux/selectors';
import StranaWelcome from './StranaWelcome';
// import LoginForm from './LoginForm';
// import StranaAdminKorisnici from './StranaAdminKorisnici';
import StranaAdminPanel from './StranaAdminPanel';


export const RouterSimpleSecondScreen = (props) => {
  const ulogovan = useSelector(selectUlogovan);
  const role = useSelector(selectRole);
  const routeSimple = useSelector(selectRouteSimple);
  let route = routeSimple.route;
  let allow_admin_panel = false;
  if (role === 'ADMIN' || role === 'DEV') {
    allow_admin_panel = true;
  }


  //
  let jsx = null;
  let is_ter_tok_page = false;


  jsx = <StranaWelcome />

  if (ulogovan === true) {
    if (route === 'ADMIN_PANEL') {
      jsx = <StranaAdminPanel />
/*
    } else if (route === 'ADMIN_USERS') {
      jsx = <StranaAdminKorisnici />
    } else if (route === 'ADMIN_TER_COMORDER') {
      jsx = <StranaAdminTerNarudzbe adminMode={allow_admin_panel} />
    } else if (route === 'ADMIN_TER_COMORDITEM') {
      jsx = <StranaAdminTerStavkeNarudzbe adminMode={allow_admin_panel} />
    } else if (route === 'ADMIN_LIB_VIRTEL_PARAMS') {
      jsx = <StranaAdminLibVirtelParams />
    } else if (route === 'ADMIN_LIB_MATERIJAL_LIM') {
      jsx = <StranaAdminLibMaterijalLim />
    } else if (route === 'ADMIN_LIB_CPARAMS') {
      jsx = <StranaAdminLibTerCparams />
    } else if (route === 'ADMIN_LIB_CNC_S4_TEMPLATE') {
      jsx = <StranaAdminLibCNCProgramS4Template />
    } else if (route === 'ADMIN_LIB_DOCUMENT') {
      jsx = <StranaAdminLibDocument />
    } else if (route === 'ADMIN_LIB_TER_CONST') {
      jsx = <StranaAdminLibTerConst />
    } else if (route === 'ADMIN_DINAMICKAF') {
      jsx = <StranaAdminDinamickaFunkcionalnost />
    } else if (route === 'ADMIN_RADNICENTRI') {
      jsx = <StranaAdminRadniCentri />

    } else if (route === 'TEMP_CNC_OPTIMIZACIJE') {
      jsx = <StranaTempCNCOptimizacije />
*/
    } else {
      jsx = 'ROUTE NOT FOUND';
      // console.log('ROUTE NOT FOUND', route);
    }
  } else {
    jsx = <StranaWelcome />
  }


  let jsx2 = jsx;
  if (is_ter_tok_page === true) {
  } else {
    // all other pages wrapped with pad
    jsx2 = (
      <div className="pad">
        {jsx}
      </div>
    );
  }

  return (
    <>
      {jsx2}
    </>
  );
};

export default RouterSimpleSecondScreen;